<template>
    <module-card :nextDisabled="nextDisabled" :nextFunction="saveBottomLine">
        <p v-html="bottomLineStatement"></p>
        <div v-for="choice in bottomLineChoices" :key="choice.id" :class="[isSelected(choice.id) ? 'primary white--text' : 'grey lighten-3']" class="pa-3 mb-1" @click.stop="select(choice.id)" v-ripple>
            {{ choice.choice }}
        </div>
        <slot></slot>
    </module-card>
</template>

<script>
    export default {
        props: {
            statement: {
                type: Number,
                required: true
            }
        },
        computed: {
            bottomLineStatement() {
                return this.$store.get(`content@bottomLineStatements[${this.statement}].statement`);
            },
            bottomLineChoices() {
                return this.$store.get(`content@bottomLineStatements[${this.statement}].choices`).map((i) => this.$store.get(`content@bottomLineChoices`)[i]);
            },
            myBottomLine() {
                return this.$store.get('myBottomLine', { moduleId: this.$route.params.module, statementId: this.statement });
            }
        },
        methods: {
            nextDisabled() {
                return this.myBottomLine === null;
            },
            select(response) {
                this.$store.set(`bottomLine@${this.$route.params.module}.myBottomLine.${this.statement}.response`, response);
            },
            isSelected(id) {
                if (parseInt(id) === parseInt(this.myBottomLine)) return true;
                else return false;
            },
            saveBottomLine() {
                // for the first bottom line module, this is redundant (bottom line is saved when user selects a response).
                // for subsequent bottom line modules, the prior response is loaded for display, but is not saved - until the
                // user clicks next, and we save that selected choice.
                this.$store.set(`bottomLine@${this.$route.params.module}.myBottomLine.${this.statement}.response`, this.myBottomLine);
            }
        }
    };
</script>
